// Header.js
//import React from 'react';
import logo from '../styles/img/enisa-database.png';


import React, { useState, useEffect } from 'react';
import { Link, useNavigate  } from 'react-router-dom';
import { appUrl } from '../properties/properties';

const Header = () => {
  const [searchText, setSearchText] = useState('');
  const [searchId, setSearchId] = useState('');
  const navigate = useNavigate();

  
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSearchClick = () => {
    navigate(`/search?text=${encodeURIComponent(searchText)}`);
  };

  const handleIdSearch = async () => {
  if (!searchId.trim()) {
    alert("Please enter a valid ID.");
    return;
  }

  try {
    // First API: Check in enisaid
    const enisaResponse = await fetch(`${appUrl}/enisaid?id=${encodeURIComponent(searchId)}`);
    if (enisaResponse.status === 200) {
      navigate(`/vulnerability/${searchId}`);
      return;
    }

    // Third API: Check in advisory
    const advisoryResponse = await fetch(`${appUrl}/advisory?id=${encodeURIComponent(searchId)}`);
    if (advisoryResponse.status === 200) {
      navigate(`/advisory/${searchId}`);
      return;
    }

    // If none of the APIs return ok
    alert("The introduced ID does not exist.");
  } catch (error) {
    console.error("Error searching by ID:", error);
    alert("An error occurred while searching. Please try again.");
  }
  };
  
  return (
    <header>
        <div className="logo-container">
            <a href="/homepage"><img src={logo} alt="ENISA"></img></a>
        </div>
        <div className="menu-container">
          <a className='margin-right header' href='/search' target='self'>Full vulnerability list</a>

          <div id="search-bar-wrapper">
            <div className='search-by-id-wrapper'>
              <form action="#" className="search" onSubmit={(e) => { e.preventDefault(); if (searchId) { handleIdSearch(); } }}>
                <label className='sr-only' id='labelSearchID' for="homeSearchID">Search vulnerabilities by ID</label>
                <input type="text" placeholder="Search by ID" id="homeSearchID" aria-labelledby='labelSearchID' value={searchId} onChange={(e) => setSearchId(e.target.value)} />
                <button className="button-search" type="submit" id="homeSearchIDButton" value="Search"><span className='sr-only'>Search vulnerabilities by ID</span></button>
              </form>
            </div>
            <div className='search-by-text-wrapper'>
              <form action="#" className="search" onSubmit={(e) => {e.preventDefault(); handleSearchClick(); }}>
                <label className='sr-only' id='labelSearchText' for="homeSearch">Search vulnerabilities by text</label>
                <input type="text" placeholder="Search by text" id="homeSearch" aria-labelledby='labelSearchText' value={searchText} onChange={handleSearchChange} />
                <button className="button-search" type="submit" id="homeSearchTextButton" value="Search"><span className='sr-only'>Search vulnerabilities by text</span></button>
              </form>
            </div>
          </div>
        </div>       
    </header>
  );
};


export default Header;

